import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/LandingPage.css';

const LandingPage: React.FC = () => {
  const navigate = useNavigate();

  const handleDeliveryClick = () => {
    navigate('/delivery-form');
  };

  return (
    <div className="landing-page">
      <div className="hero-section">
        <img src="/new_logo.JPG" alt="Wings Delivery" className="logo-image" />
        <h1 className="logo">Wings Delivery</h1>
        <h2 className="tagline">Votre service de livraison rapide à Kinshasa</h2>
        <p className="description">
          Livraison simple, rapide et fiable partout dans Kinshasa
        </p>
        <button className="cta-button" onClick={handleDeliveryClick}>
          Demander une livraison
        </button>
      </div>
      <div className="features">
        <div className="feature">
          <span className="icon">🚚</span>
          <h3>Rapide</h3>
          <p>Livraison le jour même</p>
        </div>
        <div className="feature">
          <span className="icon">💼</span>
          <h3>Fiable</h3>
          <p>Vos colis en sécurité</p>
        </div>
        <div className="feature">
          <span className="icon">📍</span>
          <h3>Partout</h3>
          <p>Dans tout Kinshasa</p>
        </div>
      </div>
      <div className="payment-info">
        <div className="payment-section">
          <span className="payment-icon">💳</span>
          <h3>Paiement Orange Money</h3>
          <p className="payment-number">+243890805200</p>
          <p className="payment-description">Payez facilement avec Orange Money</p>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;